import React from 'react';
import {
	GovAccordion,
	GovLayout,
	GovLayoutColumn,
} from '@gov-design-system-ce/react';
import type { CmsFaqListItem } from '@gov-nx/api/cms/types';
import { LocalizeNameSpaceTypes } from '@gov-nx/core/service/translations/name-space.types';
import { useLocale } from '@gov-nx/core/service/translations/useLocale';
import { AccordionItem } from '@gov-nx/ui/web/Accordion';
import { SectionHeader } from '@gov-nx/ui/web/Content/SectionHeader';
import { LayoutGap } from '@gov-nx/ui/web/Layout/LayoutGap';
import { MarkdownRender } from '../Markdown/MarkdownRender';

export interface CmsFaqProps {
	faq: CmsFaqListItem[];
	localizeNameSpace?:
		| LocalizeNameSpaceTypes.Page
		| LocalizeNameSpaceTypes.Service;
}

export const CmsFaq = ({
	faq,
	localizeNameSpace = LocalizeNameSpaceTypes.Page,
}: CmsFaqProps) => {
	const { t } = useLocale(localizeNameSpace);
	return (
		<section
			aria-labelledby="titulek-casto-se-ptate"
			className="w-full">
			<LayoutGap gap="l">
				<SectionHeader
					id="titulek-casto-se-ptate"
					headline={t('casto-se-ptate')}
				/>
				<GovLayout
					type="text"
					variant="left">
					<GovLayoutColumn>
						<GovAccordion size="m">
							{faq.map((accordion) => (
								<AccordionItem
									size="m"
									key={accordion.id}
									label={<h3>{accordion.question}</h3>}>
									<MarkdownRender>{accordion.answer}</MarkdownRender>
								</AccordionItem>
							))}
						</GovAccordion>
					</GovLayoutColumn>
				</GovLayout>
			</LayoutGap>
		</section>
	);
};
